import { render, staticRenderFns } from "./jifen-item.vue?vue&type=template&id=18c398ab&scoped=true&"
import script from "./jifen-item.vue?vue&type=script&lang=js&"
export * from "./jifen-item.vue?vue&type=script&lang=js&"
import style0 from "./jifen-item.vue?vue&type=style&index=0&id=18c398ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c398ab",
  null
  
)

export default component.exports